// extracted by mini-css-extract-plugin
export default {"container":"style_container__6Ly6I","header":"style_header__OUxlL","text":"style_text__A2MMw","loader":"style_loader__hMwmi"};